import { FC } from 'react';
import { DeploymentUnitStatus } from '@agilelab/plugin-wb-builder-common';
import { Box } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { useReleaseDetailPageContext } from '../context/useReleaseDetailPageContext';
import { useReleaseStatusAndVersion } from '../hooks/useReleaseStatusAndVersion';
import { QuickLink } from './QuickLink/QuickLink';

export const QuickLinks: FC<{ canProvision: boolean }> = ({ canProvision }) => {
  const { isDeployingAll, isUndeployingAll, entity, deployAll, undeployAll } =
    useReleaseDetailPageContext();
  const navigate = useNavigate();
  const releaseStatusAndVersion = useReleaseStatusAndVersion();

  const hide =
    !canProvision ||
    isDeployingAll ||
    isUndeployingAll ||
    releaseStatusAndVersion[0].status !== DeploymentUnitStatus.CORRUPT;

  const navigateToEditor = () => {
    navigate(
      `/catalog/${entity.metadata.namespace}/${entity.kind.toLowerCase()}/${
        entity.metadata.name
      }/editor`,
    );
  };

  return (
    <>
      {!hide && (
        <Box
          style={{
            display: 'grid',
            flexWrap: 'wrap',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            columnGap: '16px',
            rowGap: '16px',
          }}
        >
          <QuickLink type="DEPLOY_AGAIN" onClick={deployAll} />
          <QuickLink type="UNDEPLOY_ALL" onClick={undeployAll} />
          <QuickLink type="GO_TO_EDITOR" onClick={navigateToEditor} />
        </Box>
      )}
    </>
  );
};
